import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Forgot Password</h1>
        <p style={styles.sub}>Enter your email address and we'll send you a link to reset your password.</p>

        {submitted ? (
          <div style={styles.success}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>✉️</div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Check your inbox</div>
            <div style={{ color: '#666', fontSize: 13 }}>
              If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly.
            </div>
            <Link to="/login" style={styles.backLink}>Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={styles.input}
                required
              />
            </div>
            <button type="submit" style={styles.btn}>Send Reset Link</button>
            <Link to="/login" style={styles.cancel}>Back to Login</Link>
          </form>
        )}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' },
  card: { background: '#fff', padding: '48px 40px', borderRadius: 16, width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' },
  title: { fontSize: 24, fontWeight: 700, color: '#333', textAlign: 'center', marginBottom: 8 },
  sub: { fontSize: 13, color: '#999', textAlign: 'center', marginBottom: 32, lineHeight: 1.6 },
  form: { display: 'flex', flexDirection: 'column', gap: 20 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 500, color: '#555' },
  input: { padding: '12px 16px', border: '1px solid #e8e8e8', borderRadius: 8, fontSize: 14, outline: 'none' },
  btn: { padding: '14px', background: '#b39ddb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  cancel: { textAlign: 'center', fontSize: 13, color: '#aaa', textDecoration: 'none', display: 'block' },
  success: { textAlign: 'center', padding: '20px 0' },
  backLink: { display: 'inline-block', marginTop: 24, color: '#b39ddb', fontWeight: 600, fontSize: 14, textDecoration: 'none' },
};

export default ForgotPasswordPage;
